import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { RouterLink } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgChartsModule } from 'ng2-charts';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { ModalModule } from 'ngx-bootstrap/modal';

import { CapitalizeFirstLetterPipe } from './pipes/capitalize-first-letter.pipe';
import { CapitalizeInitialsPipe } from './pipes/capitalize-initials.pipe';
import { InfoboxComponent } from './components/infobox/infobox.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { PhonePipe } from './pipes/phone.pipe';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HoverModalInformationDealComponent } from '@shared/components/hover-modal/hover-modal-information-deal.component';
import { CompaniesStatisticsComponent } from '@shared/components/statistics/companies-statistics/companies-statistics.component';
import { CompanyInProgressAgentsStatisticsComponent } from '@shared/components/statistics/company-in-progress-agents-statistics/company-in-progress-agents-statistics.component';
import { ReferralCompaniesStatisticsComponent } from '@shared/components/statistics/referral-companies-statistics/referral-companies-statistics.component';
import { BankMostReportsComponent } from './components/statistics/bank-most-reports/bank-most-reports.component';

@NgModule({
  declarations: [
    CapitalizeFirstLetterPipe,
    CapitalizeInitialsPipe,
    InfoboxComponent,
    NavbarComponent,
    PaginationComponent,
    PhonePipe,
    SidebarComponent,
    HoverModalInformationDealComponent,
    CompaniesStatisticsComponent,
    CompanyInProgressAgentsStatisticsComponent,
    ReferralCompaniesStatisticsComponent,
    BankMostReportsComponent,
  ],
  imports: [
    RouterLink,
    CommonModule,
    PaginationModule,
    CollapseModule,
    BsDropdownModule,
    MatDialogModule,
    MatButtonModule,
    ModalModule,
    NgChartsModule,
    NgApexchartsModule,
  ],
  exports: [
    CapitalizeFirstLetterPipe,
    CapitalizeInitialsPipe,
    InfoboxComponent,
    NavbarComponent,
    PaginationComponent,
    PhonePipe,
    SidebarComponent,
    CompaniesStatisticsComponent,
    CompanyInProgressAgentsStatisticsComponent,
    ReferralCompaniesStatisticsComponent,
    BankMostReportsComponent,
  ],
})
export class SharedModule {}
